export function arrayLastItem(arr: any[]) {
    return arr[arr.length - 1] ?? undefined;
}